<template>
  <div>
    <div class="mt-3 px-3" v-for="email in emails" :key="email.id">
      <!-- {{ email }} -->
      <div @click="showEmailModal(email)">
        <p>Date: {{ new Date(email.timestamp) }}</p>
        <p>To: {{ email.to_email }}</p>
        <p>Subject: {{ email.subject }}</p>
        <!-- <pre>{{ email.body }}</pre> -->
      </div>
      <hr>
    </div>

    <modal name="email-details-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <p>Date: {{ new Date(email.timestamp) }}</p>
        <p>To: {{ email.to_email }}</p>
        <p>Subject: {{ email.subject }}</p>
        <hr>
        <!-- <pre>{{ email.body }}</pre> -->
        <pre v-html="email.body"></pre>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('email-details-modal')" style="">Close</button>
        <!-- <button class="mylisting-button dark-button" @click="resetPassword(user)" style="">Reset Password</button> -->
        <!-- <button class="btn btn-danger" @click="deleteUser(user)">Delete</button> -->
        <!-- <button v-if="user.status != 'Active'" class="mylisting-button dark-button" @click="approveUser(user)" style="float: right;">Activate</button> -->
        <!-- <button v-if="!note.id" class="mylisting-button dark-button" @click="addNote()" style="float: right;">Add Note</button> -->
        <!-- <button v-if="note.id" class="mylisting-button dark-button" @click="updateNote()" style="float: right;">Update Note</button> -->
        <!-- <button class="mylisting-button danger-button" @click="deleteUser(user)">Delete</button> -->
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['recipient'],
  data() {
    return {
      emails: [],
      email: {},
    }
  },
  created() {
    this.getEmails()
  },
  methods: {
    getEmails() {
      if (this.recipient) {
        axios.get(`/api/emaillogs/?agency=${this.$store.getters.agencyID}&recipient=${this.recipient.id}`)
        .then(res => {
          // console.log(res)
          this.emails = res.data
          this.emails = this.emails.sort((a, b) => (a.timestamp < b.timestamp) ? 1 : -1)
        })
        .catch(error => console.log(error))
      } else {
        axios.get(`/api/emaillogs/?agency=${this.$store.getters.agencyID}`)
          .then(res => {
            // console.log(res)
            this.emails = res.data
            this.emails = this.emails.sort((a, b) => (a.timestamp < b.timestamp) ? 1 : -1)
          })
          .catch(error => console.log(error))
      }
    },
    showEmailModal(email) {
      this.email = email
      this.$modal.show('email-details-modal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/EmailLog.vue